

export default {
  Authorization: 'Error.Authorization'
};


// WEBPACK FOOTER //
// ./src/services/ErrorType.js